/**
 * True when `value` is a same-origin path we may bounce to after login.
 * Rejects protocol-relative URLs (`//evil.example`) and anything that is
 * not a root-relative path.
 */
export const isInternalPath = (value: string): boolean =>
  value.startsWith('/') && !value.startsWith('//');
